import { useUrlState } from "../../../../../hooks/useUrlState.js";
import { LoginModel } from "../../../models/LoginModel.js";
import { LoginError } from "./LoginError.js";
import { useEffect } from "react";
import { Button, Email, FormLayout, Password } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { useFormModel } from "mvc-kit/react";
//#region src/modules/AuthWrapper2/components/Login/views/LoginForm.tsx
function LoginForm({ error, loading, onForgotPassword, onLogin, resetRequested }) {
	const [urlEmail, setUrlEmail] = useUrlState("email", void 0, { dataType: "string" });
	const { model, state, visibleErrors } = useFormModel(() => new LoginModel({
		email: urlEmail || "",
		password: ""
	}));
	useEffect(() => {
		if (urlEmail) setUrlEmail("");
	}, []);
	const handleSubmit = () => {
		if (loading) return;
		model.submit(({ email, password }) => onLogin(email, password));
	};
	const handleKeyDown = (ev) => {
		if (ev.key === "Enter" && ev.target.tagName === "INPUT") {
			ev.preventDefault();
			handleSubmit();
		}
	};
	return /* @__PURE__ */ jsx("div", {
		onKeyDown: handleKeyDown,
		children: /* @__PURE__ */ jsxs(FormLayout, {
			dividers: "space",
			horizontal: false,
			space: "sm",
			children: [
				/* @__PURE__ */ jsx(Email, {
					error: visibleErrors.email,
					label: "Email",
					onBlur: () => model.touch("email"),
					onChangeValue: model.setEmail,
					placeholder: "joe-doe@gmail.com",
					value: state.email
				}),
				/* @__PURE__ */ jsx(Password, {
					error: visibleErrors.password,
					label: "Password",
					onBlur: () => model.touch("password"),
					onChangeValue: model.setPassword,
					subText: resetRequested ? "An email was sent to your inbox with instructions to set a new password." : void 0,
					value: state.password
				}),
				/* @__PURE__ */ jsx(LoginError, { message: error }),
				/* @__PURE__ */ jsx(FormLayout.Controls, {
					extraEnd: /* @__PURE__ */ jsx(Button, {
						disabled: loading,
						variant: "main",
						subtle: true,
						onClick: onForgotPassword,
						children: "Forgot Password"
					}),
					disabled: loading,
					submitting: loading && "Logging in",
					onSubmit: handleSubmit,
					submitLabel: "Login"
				})
			]
		})
	});
}
//#endregion
export { LoginForm };

//# sourceMappingURL=LoginForm.js.map